// extracted by mini-css-extract-plugin
export var sectionTitle = "storyGrid-module--sectionTitle--QR_rn";
export var root = "storyGrid-module--root--3mTal";